import React from 'react';
import styles from './Headers.module.css';
import profile from '../../../images/profile.jpeg';
import me from '../../../images/me.png';
import { Link } from 'react-router-dom';

const Headers = () => {
    return (
        <div className={styles.bg} className="mt-5" >
            <div className="row justify-content-evenly text-center mt-5">
                <div className="col-md-6 text-start text-white mt-5">
                    <h5 className={styles.textGreen}>Hello, I'm</h5>
                    <h1 className={styles.textLight}>Rajon Ahmed</h1>
                    <h5 className={styles.textGreen}>Junior Web Developer</h5>
                    <p> A self-motivated and enthusiastic web developer with a deep interest in JavaScript. I enjoy creating modern web applications. Desire To work in the Software industry with modern web technologies of different local & multinational Software/ IT agencies of Bangladesh and grow rapidly with increasing responsibilities.</p>
                    <div className="mt-4">
                        <Link to="/about"><button type="button" className="me-4 btn btn-success">About me</button></Link>
                        <a href="https://www.linkedin.com/in/rajon749/" target="_blank"><button type="button" className="btn btn-outline-success">Contact</button></a>
                    </div>
                </div>
                <div className="col-md-4 mt-5">
                    <img src={me} alt="" className={styles.picture}/>
                </div>
            </div>
        </div>
    );
};

export default Headers;